import { PublicSharingState } from '../enums/public-sharing-state.enum';
// Constants
import { PUBLIC_SHARING_STATE_LABEL } from 'SharingApp/ts/constants';
export function isPublicShareableItem(value) {
    return (Object.prototype.hasOwnProperty.call(value, 'sharing') &&
        Object.prototype.hasOwnProperty.call(value.sharing, 'public_sharing_state'));
}
/**
 * Return the configuration for the sharing button
 * shown in the saved item list page dropdown.
 */
export function getSharingButtonConfig(option, shareableItem, hasEditFeature) {
    // Disable
    let disabled = !(hasEditFeature && shareableItem.sharing.is_owner && window.USER.shareableClientGroups.length > 0);
    if (isPublicShareableItem(shareableItem)) {
        const itemIsInApprovalState = [
            PublicSharingState.APPROVED_FOR_SHARING,
            PublicSharingState.APPROVED_FOR_UNSHARING,
        ].includes(shareableItem.sharing.public_sharing_state);
        disabled || (disabled = itemIsInApprovalState);
    }
    // Label
    let { label } = option;
    if (isPublicShareableItem(shareableItem)) {
        try {
            label = PUBLIC_SHARING_STATE_LABEL[shareableItem.sharing.public_sharing_state];
        }
        catch (error) {
            throw Error(`Invalid public sharing state ${shareableItem.sharing.public_sharing_state} 
                for item ${shareableItem.id}}`);
        }
    }
    return {
        ...option,
        label,
        disabled,
    };
}
